export default __webpack_public_path__ + "static/summer_containers3-c184cbedf5e02ee9c850da4c11393ed4.webp";